import { forwardRef } from 'react';

import Link from '@mui/material/Link';
import { useMediaQuery } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
import Box, { BoxProps } from '@mui/material/Box';

import { RouterLink } from 'src/routes/components';

import croppedLogo from './logo/logo_cropped.svg';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    // const theme = useTheme();

    // const PRIMARY_LIGHT = theme.palette.primary.light;

    // const PRIMARY_MAIN = theme.palette.primary.main;

    // const PRIMARY_DARK = theme.palette.primary.dark;
    const isMobile = useMediaQuery('(max-width: 600px)');

    // OR using local (public folder)
    // -------------------------------------------------------
    const logo = (
      <Box
        component="img"
        alt="Logo pic"
        src={croppedLogo} // => your path
        sx={{ width: isMobile ? 200 : 400, height: isMobile ? 40 : 50, cursor: 'pointer', ...sx }}
      />
    );

    // const logo = (
    //   <Box
    //     ref={ref}
    //     component="div"
    //     sx={{
    //       width: 40,
    //       height: 40,
    //       display: 'inline-flex',
    //       ...sx,
    //     }}
    //     {...other}
    //   >
    //     {/* <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512 512">
    //       <defs>
    //         <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
    //           <stop offset="0%" stopColor={PRIMARY_DARK} />
    //           <stop offset="100%" stopColor={PRIMARY_MAIN} />
    //         </linearGradient>

    //         <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
    //           <stop offset="0%" stopColor={PRIMARY_LIGHT} />
    //           <stop offset="100%" stopColor={PRIMARY_MAIN} />
    //         </linearGradient>

    //         <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
    //           <stop offset="0%" stopColor={PRIMARY_LIGHT} />
    //           <stop offset="100%" stopColor={PRIMARY_MAIN} />
    //         </linearGradient>
    //       </defs>

    //       <g fill={PRIMARY_MAIN} fillRule="evenodd" stroke="none" strokeWidth="1">
    //         <path
    //           fill="url(#BG1)"
    //           d="M183.168 285.573l-2.918 5.298-2.973 5.363-2.846 5.095-2.274 4.043-2.186 3.857-2.506 4.383-1.6 2.774-2.294 3.939-1.099 1.869-1.416 2.388-1.025 1.713-1.317 2.18-.95 1.558-1.514 2.447-.866 1.38-.833 1.312-.802 1.246-.77 1.18-.739 1.111-.935 1.38-.664.956-.425.6-.41.572-.59.8-.376.497-.537.69-.171.214c-10.76 13.37-22.496 23.493-36.93 29.334-30.346 14.262-68.07 14.929-97.202-2.704l72.347-124.682 2.8-1.72c49.257-29.326 73.08 1.117 94.02 40.927z"
    //         />
    //         <path
    //           fill="url(#BG2)"
    //           d="M444.31 229.726c-46.27-80.956-94.1-157.228-149.043-45.344-7.516 14.384-12.995 42.337-25.267 42.337v-.142c-12.272 0-17.75-27.953-25.265-42.337C189.79 72.356 141.96 148.628 95.69 229.584c-3.483 6.106-6.828 11.932-9.69 16.996 106.038-67.127 97.11 135.667 184 137.278V384c86.891-1.611 77.962-204.405 184-137.28-2.86-5.062-6.206-10.888-9.69-16.994"
    //         />
    //         <path
    //           fill="url(#BG3)"
    //           d="M450 384c26.509 0 48-21.491 48-48s-21.491-48-48-48-48 21.491-48 48 21.491 48 48 48"
    //         />
    //       </g>
    //     </svg> */}
    //     <svg
    //       width="1232"
    //       height="268"
    //       viewBox="0 0 1232 268"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         d="M408.399 126.849H386.466V89.4531H408.573C421.293 89.4531 430.679 97.3744 430.679 107.874C430.679 118.744 421.106 126.849 408.399 126.849ZM412.079 66.4277H360.319V200.902H386.466V150.06H412.079C439.159 150.06 458.506 132.376 458.506 107.874C458.506 83.7438 439.159 66.4277 412.079 66.4277Z"
    //         fill="#81A1CD"
    //       />
    //       <path
    //         d="M513.573 181.193C498.839 181.193 487.239 169.22 487.239 153.931C487.239 138.64 498.839 126.667 513.573 126.667C528.493 126.667 539.919 138.64 539.919 153.931C539.919 169.22 528.493 181.193 513.573 181.193ZM513.573 104.192C484.653 104.192 461.626 126.297 461.626 153.931C461.626 181.563 484.653 203.668 513.573 203.668C542.679 203.668 565.706 181.563 565.706 153.931C565.706 126.113 542.679 104.192 513.573 104.192Z"
    //         fill="#81A1CD"
    //       />
    //       <path
    //         d="M591.307 64.4016C582.653 64.4016 575.84 70.6643 575.84 79.1376C575.84 87.6123 582.653 93.875 591.307 93.875C600.147 93.875 607.146 87.4283 607.146 79.1376C607.146 70.6643 600.147 64.4016 591.307 64.4016Z"
    //         fill="#81A1CD"
    //       />
    //       <path d="M579.333 200.902H603.653V106.954H579.333V200.902Z" fill="#81A1CD" />
    //       <path
    //         d="M668.68 103.822C657.986 103.822 648.96 107.322 643.253 113.585V106.954H620.6V200.902H644.906V144.902C644.906 134.585 653.2 126.296 663.706 126.296C674.2 126.296 681.573 134.585 681.573 145.638V200.902H705.893V141.586C705.893 119.296 690.6 103.822 668.68 103.822Z"
    //         fill="#81A1CD"
    //       />
    //       <path
    //         d="M757.279 80.2424H732.959V106.954H716.013V128.138H732.959V200.902H757.279V128.138H778.279V106.954H757.279V80.2424Z"
    //         fill="#81A1CD"
    //       />
    //       <path
    //         d="M860.257 178.43C835.936 178.43 816.782 158.534 816.782 133.482C816.782 108.613 835.747 88.9028 859.879 88.9028C872.963 88.9028 885.117 94.7975 893.048 104.744L914.603 88.9028C901.519 72.6918 882.365 63.665 860.257 63.665C819.722 63.665 788.59 94.0596 788.59 133.298C788.59 172.904 819.911 203.668 860.257 203.668C881.987 203.668 901.708 194.641 915.696 178.245L894.154 161.113C885.117 172.536 873.53 178.43 860.257 178.43Z"
    //         fill="#5CC474"
    //       />
    //       <path
    //         d="M972.243 103.826C963.214 103.826 955.117 107.879 949.76 114.879V106.958H927.11V200.906H951.416V149.88C951.416 135.326 956.758 127.774 967.082 127.774C969.85 127.774 971.687 128.327 974.636 129.616L984.764 106.406C980.521 104.749 976.292 103.826 972.243 103.826Z"
    //         fill="#5CC474"
    //       />
    //       <path
    //         d="M1035.61 181.198C1020.87 181.198 1009.26 169.407 1009.26 153.936C1009.26 138.46 1020.87 126.671 1035.61 126.671C1050.17 126.671 1061.77 138.46 1061.77 153.936C1061.77 169.407 1050.17 181.198 1035.61 181.198ZM1063.06 115.25C1054.76 108.25 1044.08 104.196 1032.47 104.196C1005.39 104.196 983.662 126.302 983.662 153.936C983.662 181.567 1005.39 203.672 1032.47 203.672C1044.08 203.672 1054.76 199.618 1063.06 192.619V200.907H1086.09V106.961H1063.06V115.25Z"
    //         fill="#5CC474"
    //       />
    //       <path
    //         d="M1138.94 99.2218C1138.94 91.1176 1143.36 86.3261 1150.92 86.3261C1153.85 86.3261 1156.8 87.0633 1159.76 88.7226L1169.15 68.6421C1161.96 64.7743 1155.88 63.6686 1148.15 63.6686C1126.05 63.6686 1114.63 75.4585 1114.63 98.4846V106.959H1098.61V128.144H1114.63V200.906H1138.94V128.144H1160.86V106.959H1138.94V99.2218Z"
    //         fill="#5CC474"
    //       />
    //       <path
    //         d="M1210.04 106.958V80.2475H1185.73V106.958H1168.78V128.142H1185.73V200.906H1210.04V128.142H1231.05V106.958H1210.04Z"
    //         fill="#5CC474"
    //       />
    //       <path
    //         d="M201.906 119.693H163.573C158.32 108.556 146.986 100.828 133.866 100.828C115.76 100.828 101.026 115.56 101.026 133.669C101.026 151.778 115.76 166.512 133.866 166.512C147.44 166.512 159.12 158.236 164.12 146.466H191.8H266.84C267.253 142.253 267.453 137.986 267.453 133.666C267.453 128.946 267.213 124.293 266.72 119.693H201.906Z"
    //         fill="#5CC474"
    //       />
    //       <path
    //         d="M133.866 240.585C74.9463 240.585 27.0091 192.686 26.9477 133.777V133.667H26.945C26.945 133.666 26.945 133.666 26.945 133.665C26.945 74.7179 74.9063 26.7445 133.866 26.7445C178.4 26.7445 216.626 54.1152 232.68 92.9046H261.08C243.813 39.1232 193.32 0.0778805 133.866 0.0778805C60.213 0.0778805 0.27832 60.0113 0.27832 133.665C0.27832 133.739 0.281055 133.814 0.281055 133.889V267.254H26.9477V213.666C51.3331 246.179 90.1863 267.251 133.866 267.251C193.76 267.251 244.56 227.651 261.466 173.251H233.186C217.426 212.665 178.853 240.585 133.866 240.585Z"
    //         fill="#81A1CD"
    //       />
    //     </svg>
    //   </Box>
    // );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

export default Logo;
